import React, { lazy, Suspense } from 'react';

const hitComponents = {
  // post: lazy(() => import('./PostHit')),
  article: lazy(() => import('./ArticleHit')),
  product: lazy(() => import('./ProductHit')),
};

export const Hit = (props) => {
  const { hit, index, cardComponent } = props;
  var HitComponent;
  if (cardComponent) {
    HitComponent = cardComponent;
  } else {
    let isProduct = Boolean(hit.price);
    if (isProduct) {
      HitComponent = hitComponents.product;
    } else {
      HitComponent = hitComponents.article;
    }
  }
  return (
    <Suspense fallback="">
      <HitComponent {...props}></HitComponent>
    </Suspense>
  );
};
